module.exports = new __parcel__URL__("blackBg.a7db649e.jpg").toString();